
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from './controlador';
    import _ from 'lodash';
    import listado from './lista-buscador-seleccion-listado.vue';
    import estado from './lista-buscador-seleccion-estado.vue';
    import editar_estado from './lista-buscador-seleccion-editar-estado.vue';
    import editar_precio from './lista-buscador-seleccion-editar-precio.vue';
    import editar_duplicar from './lista-buscador-seleccion-editar-duplicar.vue';
    import * as Publicaciones from '@lib/MercadoLibre/Publicaciones';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Publicacion } from '@lib/MercadoLibre/Publicaciones';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            estado,
            editar_duplicar,
            editar_estado,
            editar_precio,
            listado,
        }
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorSeccion;
        public get Buscador() { return this.Controlador.Buscador; }
        public get Estado() { return this.Controlador.Buscador.Estado; }

        public get Seleccionados() { return this.Controlador.Seleccionados; }
        @Watch( 'Seleccionados' )
        onSeleccionados()
        {
            if ( this.Seleccionados.hasRows() )
            {
                this.SubModo = '';
                this.Abierto = true;
            }
            else
                this.Abierto = false;
        }
        public Abierto: boolean = false;

        public get SeleccionadosPorTipo()
        {
            let e: { Tipo: any; Publicaciones: Publicacion[]; }[] = [];
            let items = _.groupBy( this.Seleccionados, x => x.Tipo.Id );
            for ( let a of Object.keys( items ) )
            {
                e.push( { Tipo: Publicaciones.Tipos.toTipo( a ), Publicaciones: items[a] } );
            }
            return e;
        }

        public get SeleccionadosPorCuenta()
        {
            let e: { Cuenta: string; Publicaciones: Publicacion[]; }[] = [];
            let items = _.groupBy( this.Seleccionados, x => x.Cuenta);
            for ( let a of Object.keys( items ) )
            {
                e.push( { Cuenta: a , Publicaciones: items[a] } );
            }
            return e;
        }

        public SubModo: string = '';


        Cerrar()
        {
            this.Seleccionados.clear();
        }
    }
